(function() {
    if (window.tlCartGoalRules) {
        const currentProductId = window.meta?.product?.id?.toString() || 
                                 window.ShopifyAnalytics?.meta?.product?.id?.toString();
        
        // Chỉ xử lý lọc rules khi ở Product Page
        if (currentProductId) {
            const collectionIdsNorm = (window.currentProductCollections || []).map(id => String(id));

            window.tlCartGoalRules = Object.fromEntries(
                Object.entries(window.tlCartGoalRules).filter(([id, rule]) => {
                    const triggerCondition = rule.trigger_condition;
                    let triggerConditionIds = [];
                    try {
                        triggerConditionIds = JSON.parse(rule.trigger_condition_ids || "[]");
                    } catch(e) {}

                    triggerConditionIds = triggerConditionIds
                        .map(a => a?.shopify_id ? String(a.shopify_id) : "")
                        .filter(Boolean);

                    // Lọc theo Specific Product
                    if (triggerCondition === "product") {
                        return triggerConditionIds.includes(currentProductId);
                    } 
                    // Lọc theo Specific Collection
                    else if (triggerCondition === "collection") {
                        return collectionIdsNorm.some(id => triggerConditionIds.includes(id));
                    }
                    return true; // Các rule không giới hạn điều kiện
                })
            );
        }
    }
})();
